import Layout from '@/modules/layout/components/layout';
import Permissions from '@/security/permissions';
import { i18n } from '@/vueI18n';

const SettingsPage = () =>
  import('@/modules/settings/components/settings-page.vue');

export default [
  {
    path: '',
    component: Layout,
    children: [
      {
        name: 'settings',
        path: '/settings',
        component: SettingsPage,
        exact: true,
        meta: {
          auth: true,
          permission: Permissions.values.settingsEdit,
          title: i18n('metaTitle.setting')
        },
        beforeEnter: (to, from, next) => {
          document.title = to.meta.title
          next()
        }
      },
    ],
  },
];
